var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-container"},[_c('div',{staticClass:"cursor-element"},[_c('div',{staticClass:"cursor-motion"},[_c('svg',[_c('circle',{attrs:{"r":"80","cx":"100","cy":"100","fill":"none","stroke-width":"1px"}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }